import React from 'react';
import './RTAgent.css';

function RTAgent() {
  return (
    <section className="text-center pb-5 mt-5 pt-5  position-relative bg-dark" >
      <div className="rt-agent-container pt-5 pb-5">
        {/* Section Title - Figma: x:459, y:72, w:1001, h:49 */}
        

        {/* Content Row - Figma: x:312, y:198, w:1294, gap:102px, space-between */}
        <div className="rt-agent-content-row">
          {/* Left Side - Image - Figma: w:621, padding:227px 70px */}
          <div className="rt-agent-image-box">
            <img 
              src="/assets/home_page/v3/images/ai_data_integrity.png" 
              alt="RT Agent AI Data Integrity Dashboard" 
              className="rt-agent-image"
            />
          </div>

          {/* Right Side - Text Content - Figma: w:636, gap:33px */}
          <div className="rt-agent-text-content">
          <h2 className="rt-agent-title">
        AI Radiographic Inspection
        </h2>
            {/* Description - Figma: w:636, h:96 */}
            <p className="rt-agent-description">
            Purpose-built computer vision for radiographic inspection. Continuous scanning that goes beyond defect detection to enforce quality and best practices on every image.
            </p>

            {/* Cards Grid - Figma: gap:20px */}
            <div className="rt-agent-cards">
              {/* Row 1 */}
              <div className="rt-agent-cards-row">
                {/* Card 1 - Figma: w:306, padding:24px */}
                <div className="rt-agent-card">
                  <img src="/assets/img/icons/scan_welds.svg" alt="Scan Welds" className="rt-card-icon" width="48" height="48" />
                  <div className="rt-card-text-wrapper">
                    <p className="rt-card-text">Scans for missed defects on every submission</p>
                  </div>
                </div>

                {/* Card 2 - Figma: w:306, padding:24px */}
                <div className="rt-agent-card">
                  <img src="/assets/img/icons/evaluates_image.svg" alt="Quality Evaluation" className="rt-card-icon" width="48" height="48" />
                  <div className="rt-card-text-wrapper">
                    <p className="rt-card-text">Evaluates image quality and coverage per specification
                    </p>
                  </div>
                </div>
              </div>

              {/* Row 2 */}
              <div className="rt-agent-cards-row">
                {/* Card 3 - Figma: w:306, padding:24px */}
                <div className="rt-agent-card">
                  <img src="/assets/img/icons/eyes_off.svg" alt="Eyes Off" className="rt-card-icon" width="48" height="48" />
                  <div className="rt-card-text-wrapper">
                    <p className="rt-card-text">Flags poor positioning, missing views, and technical deviations</p>
                  </div>
                </div>

                {/* Card 4 - Figma: w:306, padding:24px */}
                <div className="rt-agent-card">
                  <img src="/assets/img/icons/realitime_alerts.svg" alt="Realtime Alerts" className="rt-card-icon" width="48" height="48" />
                  <div className="rt-card-text-wrapper">
                    <p className="rt-card-text">Real-time alerts to auditors with contextual review</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
   
    </section>
  );
}

export default RTAgent;

